import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Input, Button, message, Result } from 'antd'
import { tokens } from '../theme/tokens'
import './Auth.css'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const [msg, contextHolder] = message.useMessage()
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  if (submitted) {
    return (
      <div className="auth-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: tokens.colors.background }}>
        <Result
          status="success"
          title="重置链接已发送"
          subTitle="如该邮箱已注册，重置链接将发送到您的邮箱。请在 1 小时内点击链接完成重置；如未收到，请检查垃圾邮件或联系管理员。"
          extra={<Button type="primary" onClick={() => navigate('/login', { replace: true })}>返回登录</Button>}
        />
      </div>
    )
  }

  const onFinish = async (values: { email: string }) => {
    setLoading(true)
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: values.email }),
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: '提交失败' }))
        throw new Error(err.detail)
      }
      setSubmitted(true)
    } catch (e: any) {
      msg.error(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page" style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', background: tokens.colors.background,
    }}>
      {contextHolder}
      <div className="auth-card" style={{
        width: 400, padding: 40,
        background: tokens.colors.surface,
        borderRadius: tokens.radius.xl,
        border: `1px solid ${tokens.colors.border}`,
        boxShadow: tokens.shadows.card,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{
            fontSize: 28, fontWeight: 700, margin: 0,
            background: tokens.gradients.heading,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            ApexTribe
          </h1>
          <p style={{ color: tokens.colors.textMuted, marginTop: 8 }}>
            找回密码
          </p>
        </div>

        <p style={{ color: tokens.colors.textMuted, fontSize: 13, marginBottom: 20, lineHeight: 1.6 }}>
          请输入您注册时使用的邮箱，我们会向该邮箱发送重置链接（有效期 1 小时）。
        </p>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="注册邮箱"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '邮箱格式不正确' },
            ]}
          >
            <Input size="large" placeholder="your@example.com" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8 }}>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              发送重置链接
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Link to="/login" style={{ fontSize: 13, color: tokens.colors.textMuted, textDecoration: 'none' }}>
            返回登录
          </Link>
        </div>
      </div>
    </div>
  )
}
